<template>
  <table class="table table-sm table-hover custom_table">
    <thead class="custom_thead">
      <tr>
        <th>출발시간</th>
        <th>도착시간</th>
        <th>DTC</th>
        <th>상태</th>
        <th>운행시간</th>
        <th>운행거리</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in items" :key="index" @click="locationSelected(index)">
        <td>{{ item.sdate || '' }}</td>
        <td>{{ item.edate || 0 }}</td>
        <td>{{ item.dtc || '' }}</td>

        <td>
          <span :class="(item.edate) ? 'text-muted' : 'text-info'">{{ (item.edate) ? '운행종료' : '운행중' }}</span>
        </td>
        <td>{{ item.time | timeToMin }}</td>
        <td id="selected_data" @click=dataSelected(index)>
          {{ item.d_dist | commaNew }}km <i class="link_icon"> 데이터 </i>
        </td>
      </tr>
      <tr>
        <td colspan="6" class="text-center" v-show="items.length === 0">주행 이력이 없습니다.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/filter/common'
import ax from '@/api/location'

export default {
  name: 'CarSelectedList',
  props: {
    value: {
      type: Object,
      default: function () {
        return { id: null, date: null }
      }
    },
  },
  data() {
    return {
      items: []
    }
  },
  watch: {
    value: function (newVal) {
      this.getLocations(newVal.id, newVal.date)
    }
  },
  methods: {
    getLocations(id, date) {
      ax.locations(id, date, date, 1, response => {
        if (response) {
          this.items = response.items
        } else {
          this.items = []
        }
      })
    },
    locationSelected(v) {
      this.$emit('locationSelected', this.items[v])
    },

    dataSelected(v) {
      this.$emit('dataSelected', this.items[v])
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-dirs: "/img/icon/";

.custom_table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
  text-align: center;

  thead tr th {
    background-color: #F5FAFF;
    border-color: #F5FAFF;
    padding: 5px 10px;
  }

  thead tr:first-child {
    th:first-child {
      border-left: 1px solid #F5FAFF;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    th:last-child {
      border-right: 1px solid #F5FAFF;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  tbody {
    td {
      border-top: 0px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      max-width: 180px;
      vertical-align: middle;
    }

    tr:last-child td {
      border-bottom: 0px solid #f0f0f0;
    }
  }

}

.link_icon {
  font-size: 0px;
  width: 14px;
  height: 14px;
  background-image: url(/img/icon/icons_link_16.png);
  background-size: cover;
  display: inline-block;
  margin-bottom: 2px;
  vertical-align: middle;
}
</style>
